import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=2b19fa44&"
import script from "./ListDetail.vue?vue&type=script&lang=js&"
export * from "./ListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b19fa44')) {
      api.createRecord('2b19fa44', component.options)
    } else {
      api.reload('2b19fa44', component.options)
    }
    module.hot.accept("./ListDetail.vue?vue&type=template&id=2b19fa44&", function () {
      api.rerender('2b19fa44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/suppressed/ListDetail.vue"
export default component.exports